import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as d } from "react";
const o = d(
  ({ size: r = "small", className: n = "", lightBackground: e, label: a = "Laster", politeness: p = "polite", ...i }, t) => /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      "aria-label": a,
      "aria-busy": "true",
      "aria-live": p,
      role: "alert",
      title: a,
      className: `rds-loader-container ${e ? "rds-loader-container--light" : ""} ${n}`,
      "data-testid": "rds-loader",
      ...i,
      children: /* @__PURE__ */ s.jsxs(
        "div",
        {
          "data-testid": "rds-spinner",
          className: `rds-loader-container__spinner rds-loader-container__spinner__${r}`,
          children: [
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {}),
            /* @__PURE__ */ s.jsx("span", {})
          ]
        }
      )
    }
  )
);
o.displayName = "RawLoader";
export {
  o as R
};
